(function() {
  // Add sold out class to swatches
  if (typeof variantsJSON !== 'undefined' && variantsJSON.variants.length) {
    variantsJSON.variants.forEach(variant => {
      // console.log(variant);
      if (!variant.available) {
        // console.log(document.querySelector('li[data-value="' + variant.option1 + '"]').classList);
        document.querySelector('li[data-value="' + variant.option1 + '"]').classList.add('soldout');
      }
    });
  }
})();
